(function ( $ ) {

	$( document ).ready( function() {

		var banners = $('.jr-banner');

		banners.each(function() {

			var banner = $(this);
			var bannerID = banner.attr('id');
			var cookie = banner.data('dismiss-cookie');
			var closeButton = banner.find('.close-banner');

			if ( cookie && $.cookie('dismiss-' + bannerID) !== 'yes' ) {

				if ( ! navigator.cookieEnabled) return false;

				openBanner(banner);

				closeButton.click( function() {

					$.cookie('dismiss-' + bannerID, 'yes', { expires: 365, path: '/' });

				})

			} else if (typeof cookie === 'undefined' ) {

				openBanner(banner);

			}

			closeButton.click( function() {

				closeBanner(banner);


			} );

		});

	});


	function openBanner(banner) {

		banner.delay(1000).slideDown();

	}


	function closeBanner(banner) {

		banner.slideUp();

	}

}( jQuery ));